// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfoCard_wrapper__GkTlz","container":"InfoCard_container__miNTt","radial":"InfoCard_radial__TtD6R","content":"InfoCard_content__SbWeF","text":"InfoCard_text__TMwNm"};